import { useState } from "react";
import { Link } from "react-router-dom";

import { forgotPassword } from "@/modules/auth/api";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    setPending(true);
    setError(null);
    try {
      await forgotPassword({ email: email.trim() });
      setSubmitted(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not request a password reset.");
    } finally {
      setPending(false);
    }
  }

  return (
    <main className="relative flex min-h-screen flex-col items-center justify-center bg-background p-6">
      <div className="relative w-full max-w-md rounded-card border border-card-border bg-card p-6 shadow-card backdrop-blur-xl md:p-8">
        <p className="text-micro font-semibold uppercase tracking-[0.14em] text-kicker-lux">Account recovery</p>
        <h1 className="mt-2 font-sans text-2xl font-bold tracking-tight text-foreground">Reset your password</h1>
        <p className="mt-2 text-caption text-muted">
          Enter the email tied to your account and we will send a reset link if the account is eligible.
        </p>

        <form className="mt-6 space-y-5" onSubmit={handleSubmit}>
          <label className="block space-y-2">
            <span className="dl-label text-[0.58rem] text-muted">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="ui-control w-full"
              autoComplete="email"
            />
          </label>

          {submitted ? (
            <p role="status" className="rounded-control border border-success/30 bg-success/10 px-3 py-2 text-caption text-success">
              If the account exists and can sign in, a reset link has been sent.
            </p>
          ) : null}
          {error ? (
            <p role="alert" className="rounded-control border border-error/25 bg-error/5 px-3 py-2 text-caption text-error">{error}</p>
          ) : null}

          <button type="submit" disabled={pending} className="btn btn-primary w-full">
            {pending ? "Sending..." : "Send reset link"}
          </button>
        </form>

        <Link to="/login" className="mt-6 block text-center text-caption text-muted transition-colors hover:text-accent">
          Back to sign in
        </Link>
      </div>
    </main>
  );
}


